// import {Button, Col, Collapse, FormGroup, Input, Label, Row} from "reactstrap";
// import React, {useEffect, useMemo, useRef, useState} from "react";
// import useCatalogs from "hooks/useCatalogs";
// import Utils from "lib/Utils/Utils";
// import Supplier from "lib/Core/Backend/Controllers/Supplier";
// import CardType from "lib/Core/Backend/Controllers/CardType";

// function CardTypesCtl(props)
// {
// 	const {formRef, setExtraCardInfo, token, supplier,brandFromRef} = props;

// 	const supplierCtl = useMemo(() => new Supplier(token), [token]);
// 	const cardTypeCtl = useMemo(() => new CardType(token), [token]);

// 	const countryRef = useRef();
// 	const currencyRef = useRef();
// 	const productNameRef = useRef();
// 	const amountRef = useRef();
// 	const minAmountRef = useRef();
// 	const maxAmountRef = useRef();
// 	const CurrencyNameRef = useRef()

// 	const {countries, currencies} = useCatalogs();

// 	const [areDisabled, setAreDisabled] = useState(false);

// 	const handleSKU = (e) => {
// 		if(!e.target.value)
// 			return;
// 		if(!supplier)
// 			return;

		
// 	}

// 	const handleoptionData = (e) =>{
// 		const updatevalue = e.target.value;
// 		if(updatevalue && updatevalue > 0){
// 			cardTypeCtl.cardType(updatevalue,(data)=>{
//              if(data && !data.error){
// 				brandFromRef.current.sctProductName.value = data?.productName
// 				   brandFromRef.current.sctCurrencyId.value = data?.currencyId
// 				   brandFromRef.current.sctAmount.value = data?.amount
// 				   brandFromRef.current.sctLimitMinAmount.value = data?.minAmount
// 				   brandFromRef.current.sctLimitMaxAmount.value = data?.maxAmount
// 				   brandFromRef.current.currencyName.value = data?.currency
//                  }
// 			})
// 		}
// 	}

// 	useEffect(() => {
// 		// Utils.FillDropdown(countryRef.current, countries, null, null, 'Select a country');
// 		Utils.FillDropdown(currencyRef.current, currencies, null, null, 'Select a currency');
// 	}, [countries, currencies]);

// 	const [extraCardTypeInfo, setExtraCardTypeInfo] = useState(false);
// 	useEffect(() => {
// 		setExtraCardInfo(extraCardTypeInfo)
// 	}, [extraCardTypeInfo, formRef, setExtraCardInfo]);

// 	return (<>
// 		<div ref={props.formRef} style={{display: "none"}}>
// 			<Row form>
// 				<Col md="12">
// 					<FormGroup>
// 						<Label for="cardTypeId">Gift card type</Label>
// 						<Input innerRef={props.cardTypeInputRef} type="select" name="cardTypeId" id="cardTypeId" onClick={(e)=>handleoptionData(e)}>
// 							<option value="-1">Select a gift card type</option>
// 						</Input>
// 					</FormGroup>
// 				</Col>
// 			</Row>
// 			<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo ">
// 				Supplier Item
// 			</h6>
// 			<Row form>
// 				<Col md="6">
// 					<FormGroup>
// 						<Label for="gctSKU">SKU</Label>
// 						<Input type="text" name="sctSKU" id="sctSKU" onChange={handleSKU}/>
// 					</FormGroup>
// 				</Col>
// 				<Col md="6">
// 					<FormGroup className="d-none">
// 						<Label for="sctProductName">Product Name</Label>
// 						<Input innerRef={productNameRef} disabled={areDisabled} type="text" name="sctProductName" id="sctProductName" />
// 					</FormGroup>
// 				</Col>
// 			</Row>
// 			<Row form>
// 				{/* <Col md="6">
// 					<FormGroup>
// 						<Label for="sctCountryId">Country</Label>
// 						<Input innerRef={countryRef} disabled={areDisabled} type="select" name="sctCountryId" id="sctCountryId">
// 							<option value="-1">Select a country</option>
// 						</Input>
// 					</FormGroup>
// 				</Col> */}
// 				<Col md="6">
// 					<FormGroup className="d-none">
// 						<Label for="sctCurrencyId">Currency</Label>
// 						<Input innerRef={currencyRef} disabled={areDisabled} type="select" name="sctCurrencyId" id="sctCurrencyId" >
// 							<option value="-1">Select a currency</option>
// 						</Input>
// 					</FormGroup>
// 				</Col>
// 				<Col md="6">
// 					<FormGroup className="d-none">
// 						<Label for="currencyName">CurrencyName</Label>
// 						<Input innerRef={CurrencyNameRef} disabled={areDisabled} type="text" name="currencyName" id="currencyName" >
							
// 						</Input>
// 					</FormGroup>
// 				</Col>
// 			</Row>
// 			<Row form>
// 				<Col md="4" className="d-none">
// 					<FormGroup>
// 						<Label for="sctAmount">Amount</Label>
// 						<Input innerRef={amountRef} disabled={areDisabled} type="number" name="sctAmount" id="sctAmount" placeholder="Card value" />
// 					</FormGroup>
// 				</Col>
// 				<Col md="4">
// 					<FormGroup className="d-none">
// 						<Label for="sctLimitMinAmount">Minimum Amount</Label>
// 						<Input innerRef={minAmountRef} disabled={areDisabled} type="number" name="sctLimitMinAmount" id="sctLimitMinAmount" placeholder="Minimum value" />
// 					</FormGroup>
// 				</Col>
// 				<Col md="4">
// 					<FormGroup className="d-none">
// 						<Label for="sctLimitMaxAmount">Maximum Amount</Label>
// 						<Input innerRef={maxAmountRef} disabled={areDisabled} type="number" name="sctLimitMaxAmount" id="sctLimitMaxAmount" placeholder="Maximum value" />
// 					</FormGroup>
// 				</Col>
// 			</Row>
// 			<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo " onClick={() => setExtraCardTypeInfo(!extraCardTypeInfo)} style={{cursor: "pointer"}}>
// 				<i className={extraCardTypeInfo ? "fas fa-chevron-up" : "fas fa-chevron-down"}/>&nbsp;&nbsp;Override general/brand purchase limits and/or fees and discounts for this specific card type
// 			</h6>
// 			<Collapse isOpen={extraCardTypeInfo} id="extraCardTypeInfo">
// 				<Row form>
// 					<Col md="3">
// 						<FormGroup>
// 							<Label for="gctLimitMinAmount">Minimum Amount</Label>
// 							<Input type="number" name="gctLimitMinAmount" id="gctLimitMinAmount" placeholder="Minimum purchase amount in USD"/>
// 						</FormGroup>
// 					</Col>
// 					<Col md="3">
// 						<FormGroup>
// 							<Label for="gctLimitMaxAmount">Maximum Amount</Label>
// 							<Input type="number" name="gctLimitMaxAmount" id="gctLimitMaxAmount" placeholder="Maximum purchase amount in USD"/>
// 						</FormGroup>
// 					</Col>
// 					<Col md="3">
// 						<FormGroup>
// 							<Label for="gctLimitMinQuantity">Minimum Quantity</Label>
// 							<Input type="number" name="gctLimitMinQuantity" id="gctLimitMinQuantity" placeholder="Minimum number of cards"/>
// 						</FormGroup>
// 					</Col>
// 					<Col md="3">
// 						<FormGroup>
// 							<Label for="gctLimitMaxQuantity">Maximum Quantity</Label>
// 							<Input type="number" name="gctLimitMaxQuantity" id="gctLimitMaxQuantity" placeholder="Maximum number of cards"/>
// 						</FormGroup>
// 					</Col>
// 				</Row>
// 				<Row form>
// 					<Col md="12">
// 						<FormGroup>
// 							<Label for="gctTimeThreshold">Time period on which this limits refresh</Label>
// 							<Input type="select" name="gctTimeThreshold" id="gctTimeThreshold">
// 								<option value="-1">Select a time period</option>
// 								<option value="7">1 Week (7 days)</option>
// 								<option value="14">2 Weeks (14 days)</option>
// 								<option value="28">4 Weeks (28 days)</option>
// 								<option value="1m">Last day of the month</option>
// 							</Input>
// 						</FormGroup>
// 					</Col>
// 				</Row>
// 				<Row form>
// 					<Col md="6">
// 						<FormGroup>
// 							<Label for="gctDiscount">Brand Discount</Label>
// 							<Input type="number" name="gctDiscount" id="gctDiscount" placeholder="Discount percentage for purchases"/>
// 						</FormGroup>
// 					</Col>
// 					<Col md="6">
// 						<FormGroup>
// 							<Label for="gctFee">Brand Fee</Label>
// 							<Input type="number" name="gctFee" id="gctFee" placeholder="Fee charged per purchase"/>
// 						</FormGroup>
// 					</Col>
// 				</Row>
// 			</Collapse>
// 		</div>
// 		<Row form>
// 			<Col md="12" className="justify-content-end text-right">
// 				<Button type="button" color="primary" onClick={props.onAdd}>Add card type</Button>
// 			</Col>
// 		</Row>
// 	</>);
// }

// export default CardTypesCtl;


import {Button, Col, Collapse, FormGroup, Input, Label, Row} from "reactstrap";
import React, {useEffect, useMemo, useRef, useState} from "react";
import useCatalogs from "hooks/useCatalogs";
import Utils from "lib/Utils/Utils";
import Supplier from "lib/Core/Backend/Controllers/Supplier";
import CardType from "lib/Core/Backend/Controllers/CardType";

function CardTypesCtl(props)
{
	const {formRef, setExtraCardInfo, token, supplier,brandFromRef,
		setProductName,
		 setCurrencyName,
		 setAmount,
		 setMinimumAmount,
		 setMaximumAmount,
		 setCurrencyId,
		currencyName,minimumAmount,maximumAmount,
		amount,productName,currencyId
										
	} = props;

	const supplierCtl = useMemo(() => new Supplier(token), [token]);
	const cardTypeCtl = useMemo(() => new CardType(token), [token]);




	const countryRef = useRef();
	const currencyRef = useRef();
	const productNameRef = useRef();
	const amountRef = useRef();
	const minAmountRef = useRef();
	const maxAmountRef = useRef();
	const CurrencyNameRef = useRef()

	const {countries, currencies} = useCatalogs();

	const [areDisabled, setAreDisabled] = useState(false);

	const handleSKU = (e) => {
		if(!e.target.value)
			return;
		if(!supplier)
			return;

		
	}



  
	const handleOptionData = (e) =>{
		const updatevalue = e.target.value;
		if(updatevalue && updatevalue > 0){
			cardTypeCtl.cardType(updatevalue,(data)=>{
             if(data && !data.error){
				
				setProductName(data?.productName);
				setCurrencyId(data?.currencyId);
				setCurrencyName(data?.currency);
				setAmount(data?.amount);
				setMinimumAmount(data?.minAmount);
				setMaximumAmount(data?.maxAmount);
				const options ={
					value: data?.currencyId,
					label:data?.currency
				}
				}
			})
		}
	}

	useEffect(() => {
		// Utils.FillDropdown(countryRef.current, countries, null, null, 'Select a country');
		Utils.FillDropdown(currencyRef.current, currencies, null, null, 'Select a currency');
	}, [countries, currencies]);

	const [extraCardTypeInfo, setExtraCardTypeInfo] = useState(false);
	useEffect(() => {
		setExtraCardInfo(extraCardTypeInfo)
	}, [extraCardTypeInfo, formRef, setExtraCardInfo]);

	return (<>
		<div ref={props.formRef} style={{display: "none"}}>
			<Row form>
				<Col md="12">
					<FormGroup>
						<Label for="cardTypeId">Gift card type</Label>
						<Input innerRef={props.cardTypeInputRef} type="select" name="cardTypeId" id="cardTypeId" onChange={(e)=>handleOptionData(e)}>
							<option value="-1">Select a gift card type</option>
						</Input>
					</FormGroup>
				</Col>
			</Row>
			<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo ">
				Supplier Item
			</h6>
			<Row form>
				<Col md="6">
					<FormGroup>
						<Label for="gctSKU">SKU</Label>
						<Input type="text" name="sctSKU" id="sctSKU" onChange={handleSKU}/>
					</FormGroup>
				</Col>
				<Col md="6">
					<FormGroup className="d-none">
						<Label for="sctProductName">Product Name</Label>
						<Input disabled={areDisabled} type="text" name="sctProductName" id="sctProductName" value={productName} onChange={(e)=>setProductName(e.target.value)} />
					</FormGroup>
				</Col>
			</Row>
			<Row form>
				{/* <Col md="6">
					<FormGroup>
						<Label for="sctCountryId">Country</Label>
						<Input innerRef={countryRef} disabled={areDisabled} type="select" name="sctCountryId" id="sctCountryId">
							<option value="-1">Select a country</option>
						</Input>
					</FormGroup>
				</Col> */}
				<Col md="6">
					<FormGroup className="d-none">
						<Label for="sctCurrencyId">Currency</Label>
						<Input innerRef={currencyRef} disabled={areDisabled} type="select" name="sctCurrencyId" id="sctCurrencyId" >
							<option value="-1">Select a currency</option>
						</Input>
					</FormGroup>
				</Col>
				<Col md="6">
					<FormGroup className="d-none">
						<Label for="currencyName">CurrencyName</Label>
						<Input disabled={areDisabled} type="text" name="currencyName" id="currencyName" value={currencyName} onChange={(e)=>setCurrencyName(e.target.value)} >
							
						</Input>
					</FormGroup>
				</Col>
			</Row>
			<Row form>
				<Col md="4" className="d-none">
					<FormGroup>
						<Label for="sctAmount">Amount</Label>
						<Input  disabled={areDisabled} type="number" name="sctAmount" id="sctAmount" placeholder="Card value" value={amount} onChange={(e)=>setAmount(e.target.value)}/>
					</FormGroup>
				</Col>
				<Col md="4">
					<FormGroup className="d-none">
						<Label for="sctLimitMinAmount">Minimum Amount</Label>
						<Input  disabled={areDisabled} type="number" name="sctLimitMinAmount" id="sctLimitMinAmount" placeholder="Minimum value"  value={minimumAmount} onChange={(e)=>setMinimumAmount(e.target.value)} />
					</FormGroup>
				</Col>
				<Col md="4">
					<FormGroup className="d-none">
						<Label for="sctLimitMaxAmount">Maximum Amount</Label>
						<Input  disabled={areDisabled} type="number" name="sctLimitMaxAmount" id="sctLimitMaxAmount" placeholder="Maximum value" value={maximumAmount} onChange={(e)=>setMaximumAmount(e.target.value)}/>
					</FormGroup>
				</Col>
			</Row>
			<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo  d-flex py-2 align-items-center d-flex py-4 align-items-center" onClick={() => setExtraCardTypeInfo(!extraCardTypeInfo)} style={{cursor: "pointer"}}>
				<i className={extraCardTypeInfo ? "fas fa-chevron-up" : "fas fa-chevron-down"}/>&nbsp;&nbsp;Override general/brand purchase limits and/or fees and discounts for this specific card type
			</h6>
			<Collapse isOpen={extraCardTypeInfo} id="extraCardTypeInfo">
				<Row form>
					<Col md="3">
						<FormGroup>
							<Label for="gctLimitMinAmount">Minimum Amount</Label>
							<Input type="number" name="gctLimitMinAmount" id="gctLimitMinAmount" placeholder="Minimum purchase amount in USD"/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label for="gctLimitMaxAmount">Maximum Amount</Label>
							<Input type="number" name="gctLimitMaxAmount" id="gctLimitMaxAmount" placeholder="Maximum purchase amount in USD"/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label for="gctLimitMinQuantity">Minimum Quantity</Label>
							<Input type="number" name="gctLimitMinQuantity" id="gctLimitMinQuantity" placeholder="Minimum number of cards"/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label for="gctLimitMaxQuantity">Maximum Quantity</Label>
							<Input type="number" name="gctLimitMaxQuantity" id="gctLimitMaxQuantity" placeholder="Maximum number of cards"/>
						</FormGroup>
					</Col>
				</Row>
				<Row form>
					<Col md="12">
						<FormGroup>
							<Label for="gctTimeThreshold">Time period on which this limits refresh</Label>
							<Input type="select" name="gctTimeThreshold" id="gctTimeThreshold">
								<option value="-1">Select a time period</option>
								<option value="7">1 Week (7 days)</option>
								<option value="14">2 Weeks (14 days)</option>
								<option value="28">4 Weeks (28 days)</option>
								<option value="1m">Last day of the month</option>
							</Input>
						</FormGroup>
					</Col>
				</Row>
				<Row form>
					<Col md="6">
						<FormGroup>
							<Label for="gctDiscount">Brand Discount</Label>
							<Input type="number" name="gctDiscount" id="gctDiscount" placeholder="Discount percentage for purchases"/>
						</FormGroup>
					</Col>
					<Col md="6">
						<FormGroup>
							<Label for="gctFee">Brand Fee</Label>
							<Input type="number" name="gctFee" id="gctFee" placeholder="Fee charged per purchase"/>
						</FormGroup>
					</Col>
				</Row>
			</Collapse>
		</div>
		<Row form>
			<Col md="12" className="justify-content-end text-right">
				<Button type="button" className="btn btn-primaryTwo" onClick={props.onAdd}>Add card type</Button>
			</Col>
		</Row>
	</>);
}

export default CardTypesCtl;

